import { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

const context = {
    job: null,
    setJob: () => {},
    whiteLabeling: {},
    updateWhiteLabeling: () => {}
}

export const JobContext = createContext(context);

const sessionJob = window.sessionStorage.getItem('job');

const JobContextProvider = ({ children }) => {
    const [job, setJob] = useState(sessionJob !== null ? JSON.parse(sessionJob) : null);
    const [whiteLabeling, setWhiteLabeling] = useState({});

    const updateWhiteLabeling = (key, data) => {
        setWhiteLabeling(prev => ({
            ...prev,
            [key]: data
        }));
    }

    const _setJob = (job) => {
        setJob(job);
        if (job === null) {
            window.sessionStorage.removeItem('job');
        } else {
            window.sessionStorage.setItem('job', JSON.stringify(job));
        }
    }

    const providerValue = useMemo(() => (
        { job, setJob: _setJob, updateWhiteLabeling, whiteLabeling }
    ), [job, _setJob, updateWhiteLabeling, whiteLabeling]);

    return (
        <JobContext.Provider value={providerValue}>
            {children}
        </JobContext.Provider>
    )
}

JobContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default JobContextProvider;
